import { render, staticRenderFns } from "./wordcontent.vue?vue&type=template&id=4593a3aa&scoped=true"
import script from "./wordcontent.vue?vue&type=script&lang=js"
export * from "./wordcontent.vue?vue&type=script&lang=js"
import style0 from "./wordcontent.vue?vue&type=style&index=0&id=4593a3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593a3aa",
  null
  
)

export default component.exports